import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { LevelCard } from './styled';

@injectIntl
@inject('onboardingStore')
@observer
class Advanced1Card extends React.Component {
  render() {
    const { intl, onboardingStore } = this.props;
    const highlighted = onboardingStore.flow === 'advanced_1';
    return (
      <LevelCard
        title="Expert"
        type="onboarding-advanced1"
        description={intl.formatMessage({ id: 'onboarding.screen2.advanced1' })}
        coverheight={118.2}
        highlighted={highlighted}
        clickHandler={e => {
          e.preventDefault();
          onboardingStore.setFlow('advanced_1');
          onboardingStore.setUserType('master');
        }}
      />
    );
  }
}

Advanced1Card.propTypes = {
  onboardingStore: PropTypes.object,
  intl: PropTypes.object,
};

export default Advanced1Card;
